import styled, { css } from 'styled-components';
import Colors from '../../theme/Colors';

interface ConatinerProps {
  showScrollbar?: boolean;
}

export const Container = styled.div`
  background-color: ${Colors.background};
  /* height: calc(100vh - 120px); */
  width: calc(100% - 120px - 310px);
  margin-left: 120px;
  height: 100%;
  overflow: auto;

  @media (max-width: 845px) {
    width: calc(100% - 120px);
  }

  @media (max-width: 490px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const SearchContainer = styled.div`
  width: 100%;
  height: 80px;
  padding: 16px;

  > div {
    background-color: #fff;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
    padding: 4px 12px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  span {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${Colors.secondary};
    color: #fff;
    margin-right: 12px;
  }

  input {
    border: 0;
    width: 100%;
    height: 100%;
    outline: none;
  }

  button {
    font-size: 24px;
    background-color: transparent;
    outline: none;
    color: ${Colors.grayDark};
  }
`;

export const ProductsContainer = styled.div<ConatinerProps>`
  height: calc(100vh - 80px);
  width: 100%;

  @media (max-width: 490px) {
    height: calc(100vh - 80px - 120px);
  }

  padding: 16px;

  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-rows: 1fr 1fr 1fr 1fr;
  gap: 1rem;
  overflow: scroll;

  &::-webkit-scrollbar {
    width: 0;
  }

  ${props =>
    props.showScrollbar &&
    css`
      &::-webkit-scrollbar {
        width: unset;
      }
    `}

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    /* grid-template-rows: 1fr 1fr 1fr; */
  }

  @media (max-width: 955px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    /* grid-template-rows: 1fr 1fr; */
  }
`;

export const Product = styled.div`
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
  height: 200px;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 100px;
    height: 100px;
    margin-bottom: 12px;
    object-fit: cover;
    border-radius: 8px;
  }

  > p {
    margin: 0;
    text-align: center;

    span {
      font-size: 12px;
      color: #898989;
    }
  }
`;

export const Margin = styled.div`
  @media (max-width: 490px) {
    margin-bottom: 80px;
  }
`;
